(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["size-charts"] && !Shopify.designMode) return;
  try {
    (function () {
  function bind(root) {
    if (root.dataset.sizechartBound) return;
    root.dataset.sizechartBound = '1';
    var openBtn = root.querySelector('[data-sizechart-open]');
    var overlay = root.querySelector('[data-sizechart-overlay]');
    if (!openBtn || !overlay) return;
    var dialog = overlay.querySelector('[data-sizechart-dialog]');
    var closeBtn = overlay.querySelector('[data-sizechart-close]');
    var lastFocused = null;

    function open() {
      lastFocused = document.activeElement;
      overlay.hidden = false;
      overlay.offsetHeight;
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      (closeBtn || dialog).focus();
      document.addEventListener('keydown', onKeydown);
    }
    function close() {
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKeydown);
      window.setTimeout(function () { overlay.hidden = true; }, 200);
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }
    function onKeydown(e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Tab') trap(e);
    }
    function trap(e) {
      var f = dialog.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
  }
  function init() { document.querySelectorAll('[data-sizechart]').forEach(bind); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', init);
})();
  } catch(e) { console.error(e); }
})();

})();
